import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { TUploadData, TCommentType } from '@entities/comment/model/types';
import { commentsApi } from '@widgets/Comments/api';

type TSaveCommentVariables = {
    positionGuid: string;
    commentType: TCommentType;
    data: TUploadData;
};

type TSaveCommentMutationFn = (
    variables: TSaveCommentVariables
) => ReturnType<typeof commentsApi.saveCommentQueryOptions>;

type TUseSaveCommentOptions = Omit<
    UseMutationOptions<Awaited<ReturnType<TSaveCommentMutationFn>>, unknown, TSaveCommentVariables>,
    'mutationFn'
>;

export const useSaveComment = ({ ...mutationOptions }: TUseSaveCommentOptions) =>
    {
        const queryClient = useQueryClient();

        return useMutation({
            ...mutationOptions,
            mutationFn: commentsApi.saveCommentQueryOptions,
            onSuccess: async (data, variables, context) => {
                await queryClient.invalidateQueries({
                    queryKey: commentsApi.getCommentListQueryOptions({
                        positionGuid: variables.positionGuid,
                        commentType: variables.commentType,
                    }).queryKey,
                });

                await mutationOptions.onSuccess?.(data, variables, context);
            },
        });
    };
